import { Editor, Entity } from 'tm2-draft-js';

import React from 'react';

import { observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import type DraftStore from 'bz-draft/modules/stores/draft-store';

import refs from 'bz-utilities/modules/legacy/refs';

import DraftBase from '../../base/draft-base';
import Errors from '../errors';
import Toolbar from '../toolbar';

//console.error = (function() {
//  let error = console.error;
//
//  return function(exception) {
//    if ((exception + '').indexOf('Warning: A component is `contentEditable`') != 0) {
//      error.apply(console, arguments)
//    }
//  }
//})()

export interface IProps {
  readOnly?: boolean;
  store: DraftStore;
}

@observer
class EditorComponent extends DraftBase<IProps> {
  readonly editor = React.createRef<Editor>();

  constructor(props: IProps) {
    super(props);
    this.styleMap = Object.assign(this.styleMap, {
      SUMMARY: { background: 'lightblue', display: 'inline-block' },
      HIGHLIGHT: { background: 'lightgreen', display: 'inline-block' }
    });
  }

  @bind
  focus() {
    this.editor.current?.focus();
  }

  render() {
    const { store } = this.props;
    const { mode, editor, highlight, toolbar, errors, blockRenderMap } = store;
    toolbar.forEach((t) => {
      t.value.forEach((v) => {
        if (typeof v.style === 'string') {
          return;
        }
        this.styleMap[`${t.prefix}-${v.key}`] = v.style;
      });
    });

    let err;
    if (!this.props.readOnly) {
      err = <Errors value={errors} />;
    }

    let toolbarContent;
    if (mode != 'live') {
      toolbarContent = <Toolbar store={store} />;
    }

    return (
      <div className="editor">
        {toolbarContent}
        <div className="editor-view">
          <div className="editor-content">
            <div>
              <Editor
                ref={this.editor}
                style={{ minHeight: 400 }}
                blockRendererFn={this.blockRendererFn}
                blockRenderMap={blockRenderMap}
                blockStyleFn={this.blockStyleFn}
                customStyleMap={this.styleMap}
                editorState={editor}
                handleDrop={this.onDrop}
                handleBeforeInput={this.onBeforeInput}
                readOnly={mode === 'live' && !highlight}
                tabIndex={0}
                onChange={this.onTemplate}
              />
            </div>
          </div>
          {err}
        </div>
      </div>
    );
  }

  @bind
  onBeforeInput() {
    if (this.props.store.highlight) {
      return 'handled';
    }
  }

  @bind
  onDrop(selection, data) {
    let { types } = data;
    let { store } = this.props;

    let move = types.some((x) => x === 'move');
    let insert = types.some((x) => x === 'insert');

    if (!insert && !move) {
      return false;
    }

    let entityKey = data.getText();
    let type = Entity.get(entityKey).getType();
    let fn = (insert ? 'insert' : 'move') + (type === 'Group' ? 'Group' : 'Control');
    store[fn](entityKey, selection);
    if (insert === 'move') {
      this.focus();
    }
    return true;
  }

  @bind
  onTemplate(state) {
    this.props.store.onTemplate(state);
  }
}

export default EditorComponent;
